document.addEventListener('DOMContentLoaded', function () {
  // Identify the form type by checking for the custom classes
  const formElement =
    document.querySelector('.custom-satisfaction-form') ||
    document.querySelector('.custom-contact-us-form');

  // Exit if the form is not one of the custom forms or has been replaced by the confirmation message
  if (!formElement || document.querySelector('.gform_confirmation_wrapper')) {
    return;
  }

  const clinicDropdownContainer = document.querySelector(
    '.custom-clinics-dropdown'
  );
  if (!clinicDropdownContainer) {
    console.error('Clinic dropdown container not found');
    return;
  }

  const clinicDropdown = clinicDropdownContainer.querySelector('select');
  if (!clinicDropdown) {
    console.error('Clinic dropdown not found');
    return;
  }

  // Function to normalize text by removing accents, replacing hyphens with spaces, ignoring apostrophes, and converting to lowercase
  function normalizeText(text) {
    return text
      .normalize('NFD') // Normalize to decompose accents
      .replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/-/g, ' ') // Replace hyphens with spaces
      .replace(/'/g, '') // Remove apostrophes
      .replace(/’/g, '') // Remove apostrophes
      .toLowerCase(); // Convert to lowercase
  }

  // Function to clear all options from the dropdown
  function clearDropdown(dropdown) {
    const tsInstance = dropdown.tomselect;

    if (tsInstance) {
      tsInstance.clearOptions(); // Clear options in TomSelect
      tsInstance.clear(); // Clear selected value in TomSelect
    } else {
      while (dropdown.options.length > 0) {
        dropdown.remove(0);
      }
    }
  }

  // Function to fetch experts based on clinic post_title
  function fetchExpertsForClinic(clinicName) {
    const expertDropdownContainer = document.querySelector(
      '.custom-experts-dropdown'
    );
    if (!expertDropdownContainer) {
      console.error('Expert dropdown container not found');
      return;
    }

    const expertDropdown = expertDropdownContainer.querySelector('select');
    clearDropdown(expertDropdown);

    clinicName = normalizeText(clinicName);

    // Check if the clinicName exists in the dropdown options
    const validOption = Array.from(clinicDropdown.options).find(
      (option) => normalizeText(option.value) === clinicName
    );

    if (clinicName && validOption && validOption.index > 0) {
      // Make an AJAX request to fetch the experts for the selected clinic
      fetch(`/wp-json/custom/v1/get-experts/?clinic_name=${validOption.value}`)
        .then((response) => response.json())
        .then((data) => {
          if (data && !data.code) {
            populateExpertsDropdown(data, expertDropdown); // Populate dropdown with fetched experts
          } else {
            console.error(
              'No experts found for this clinic or an error occurred.'
            );
          }
        })
        .catch((error) => {
          console.error('Error fetching experts:', error);
        });
    }
  }

  // Function to populate the experts dropdown with the fetched experts
  function populateExpertsDropdown(experts, expertDropdown) {
    const tsInstance = expertDropdown.tomselect;

    if (tsInstance) {
      experts.forEach((expert) => {
        tsInstance.addOption({ value: expert.name, text: expert.name });
      });
      tsInstance.refreshOptions();
    } else {
      experts.forEach((expert) => {
        const option = document.createElement('option');
        option.value = expert.name; // Set value as post_title
        option.textContent = expert.name;
        expertDropdown.appendChild(option);
      });
    }
  }

  // Function to pre-select the clinic based on URL query string
  function preselectClinic() {
    const clinicName = getClinicNameFromQuery();
    if (clinicName) {
      for (let i = 0; i < clinicDropdown.options.length; i++) {
        if (normalizeText(clinicDropdown.options[i].value) === clinicName) {
          clinicDropdown.selectedIndex = i;

          // Fetch experts for the preselected clinic
          if (formElement.classList.contains('custom-satisfaction-form')) {
            fetchExpertsForClinic(clinicDropdown.options[i].value);
          }
          break;
        }
      }
    }
  }

  // Function to get the clinic name from the URL query string
  function getClinicNameFromQuery() {
    const urlParams = window.location.search;
    if (urlParams) {
      let clinicName = urlParams.slice(1).split('/')[0]; // Remove the '?' and extract the part before the slash
      clinicName = decodeURIComponent(clinicName); // Decode URL-encoded characters
      return normalizeText(clinicName); // Normalize the clinic name
    }
    return null;
  }

  // Pre-select the clinic if clinic_name is in the URL query string
  preselectClinic();

  // Event listener for clinic selection change
  clinicDropdown.addEventListener('change', function () {
    const clinicName = clinicDropdown.value;
    if (formElement.classList.contains('custom-satisfaction-form')) {
      fetchExpertsForClinic(clinicName);
    }
  });
});
